import { Form } from "antd";
import TextArea from "antd/es/input/TextArea";
import { DefaultButton } from "components/Shared/DefaultButton";
import { DefaultModal } from "components/Shared/DefaultModal";
import { useRejectFixtureTask } from "hooks/useFixtureTaskApi";
import { useRejectSeasonTask } from "hooks/useSeasonTaskApi";
import { useState } from "react";
import { useIntl } from "react-intl";

type Props = {
  entityId: string;
  season?: any;
  fixture?: any;
};

export const RejectButton = ({ entityId, season, fixture }: Props) => {
  const [openModal, setOpenModal] = useState(false);
  const { formatMessage } = useIntl();
  const [form] = Form.useForm();
  const { mutate: rejectSeasonTask, isPending: isSeasonTaskRejecting } = useRejectSeasonTask();
  const { mutate: rejectFixtureTask, isPending: isFixtureTaskRejecting } = useRejectFixtureTask();

  const onReject = async () => {
    const formData = await form.validateFields();
    if (fixture) {
      rejectFixtureTask({
        entityId: entityId,
        seasonId: fixture.seasonId,
        fixtureId: fixture.fixtureId,
        data: formData,
      });
    } else if (season) {
      rejectSeasonTask({
        entityId: entityId,
        seasonId: season.seasonId,
        data: formData,
      });
    }

    setOpenModal(false);
  };

  return (
    <>
      <DefaultButton onClick={() => setOpenModal(true)} icon={<i className="fa-solid fa-xmark"></i>}>
        {formatMessage({ id: "button.reject" })}
      </DefaultButton>
      {openModal && (
        <DefaultModal
          width={undefined}
          open={openModal}
          onOk={onReject}
          title={formatMessage(
            { id: "rejectModal.title" },
            {
              objectType: formatMessage({
                id: fixture ? "objectType.fixture" : "objectType.season",
              }),
            }
          )}
          onCancel={() => setOpenModal(false)}
          cancelText={formatMessage({ id: "button.cancel" })}
          okButtonProps={{
            loading: isSeasonTaskRejecting || isFixtureTaskRejecting,
          }}
          cancelButtonProps={{
            disabled: isSeasonTaskRejecting || isFixtureTaskRejecting,
          }}
          okText={formatMessage({ id: "button.reject" })}
        >
          <Form colon={false} form={form}>
            <Form.Item
              name="comment"
              rules={[
                {
                  required: true,
                  message: formatMessage({
                    id: "rejectModal.rejectTextArea.requredField",
                  }),
                },
              ]}
            >
              <TextArea
                rows={4}
                placeholder={formatMessage({
                  id: "rejectModal.rejectTextArea.placeholder",
                })}
              />
            </Form.Item>
          </Form>
        </DefaultModal>
      )}
    </>
  );
};
